import {
    BonusSettlementStatus,
    BonusSettlementSupplierStatus,
    DemandState,
    DemandTopicStatus,
    DocumentStatus,
    EmployeeAccess,
    ImportStatus,
    ImportSupplierStatus,
    InquiryOfferState,
    OfferStatus,
    SalesOrderStatus,
    SponsorBannerStatus,
    StatusStateType,
    UserStatus,
} from '@synergy/models';
import { ChipPropsColorOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';

type TranslationObject = {
    [Status in StatusStateType]: OverridableStringUnion<
        'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
        ChipPropsColorOverrides
    >;
};

export const getChipColor = (value: StatusStateType) => translationObject[value];

const translationObject: TranslationObject = {
    [DocumentStatus.Created]: 'default',
    [DocumentStatus.Ongoing]: 'warning',
    [DocumentStatus.Completed]: 'success',
    [DocumentStatus.CompletedWithoutTransition]: 'error',
    [DocumentStatus.CompletedWithTransition]: 'success',
    [DocumentStatus.Canceled]: 'error',
    [DocumentStatus.Scheduled]: 'primary',
    [DocumentStatus.Paused]: 'warning',

    [DemandState.Open]: 'default',
    [DemandState.NoDemand]: 'warning',
    [DemandState.DemandReported]: 'warning',
    [DemandState.ClosedNoDemand]: 'error',
    [DemandState.ClosedWithDemand]: 'success',

    [OfferStatus.Pending]: 'warning',
    [OfferStatus.Accepted]: 'success',
    [OfferStatus.Declined]: 'error',

    [InquiryOfferState.Open]: 'default',
    [InquiryOfferState.OnGoing]: 'warning',
    [InquiryOfferState.Closed]: 'success',
    [InquiryOfferState.Declined]: 'error',

    [UserStatus.ShopAdmin]: 'primary',
    [UserStatus.SupplierAdmin]: 'primary',
    [UserStatus.NoUser]: 'default',
    [EmployeeAccess.None]: 'default',
    [EmployeeAccess.Invited]: 'warning',
    [EmployeeAccess.Locked]: 'error',
    [EmployeeAccess.Disabled]: 'error',
    [EmployeeAccess.Active]: 'success',
    [UserStatus.Locked]: 'error',
    [UserStatus.ShopUser]: 'success',
    [UserStatus.SupplierUser]: 'success',
    [UserStatus.NotActivated]: 'error',

    [ImportStatus.Receiving]: 'warning',
    [ImportStatus.DeleteExistingProducts]: 'warning',
    [ImportStatus.CreatingCategories]: 'warning',
    [ImportStatus.ReadyToPublish]: 'default',
    [ImportStatus.Calculating]: 'warning',
    [ImportStatus.Published]: 'success',
    [ImportStatus.Aborted]: 'error',
    [ImportStatus.Publishing]: 'warning',
    [ImportStatus.Archived]: 'success',

    [DemandTopicStatus.Assigned]: 'success',
    [DemandTopicStatus.Unassigned]: 'default',
    [DemandTopicStatus.NotInterested]: 'warning',

    [SalesOrderStatus.CartPending]: 'default',
    [SalesOrderStatus.CompletedWithApproval]: 'success',

    [BonusSettlementStatus.Draft]: 'default',
    [BonusSettlementStatus.Sent]: 'warning',
    [BonusSettlementStatus.Completed]: 'success',
    [BonusSettlementStatus.ReadyToComplete]: 'info',
    [BonusSettlementStatus.Pending]: 'warning',

    [BonusSettlementSupplierStatus.AutomaticallySent]: 'warning',
    [BonusSettlementSupplierStatus.PartiallySent]: 'warning',
    [BonusSettlementSupplierStatus.Reclaimed]: 'error',

    [SponsorBannerStatus.Active]: 'success',
    [SponsorBannerStatus.Inactive]: 'default',

    [ImportSupplierStatus.OnSchedule]: 'success',
    [ImportSupplierStatus.Overdue]: 'warning',
    [ImportSupplierStatus.NoInterval]: 'default',
};
